<template>
  <ResponsiveLayout
    sticky-actions
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
  >
    <template #header_end>
      <BaseModal>
        <template #trigger="{ open }">
          <ButtonInfo @click="open" />
        </template>
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b_quiz_cat_copyright')"
        />
      </BaseModal>
    </template>

    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <p
          class="kds-typography-display-small kds-typography-center"
          v-html="$t('medical_profile_cat_title')"
        />

        <p
          class="kds-typography-paragraph-large kds-typography-center"
          v-html="$t('b2b_quiz_cat_welcome_content')"
        />
      </div>

      <div class="figure">
        <img
          src="@shared/assets/img/b2b/relaxation.svg"
          alt=""
        />
      </div>
    </div>
    <template #actions>
      <BaseButton
        data-qa="submit"
        :text="$t('b2b_self_test_button_start')"
        variant="outlined"
        @click="startSurvey"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { useRouter } from 'vue-router'

import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ROUTE from '@shared/modules/assessment/router/names'
import BaseModal from '@shared/components/BaseModal.vue'
import ButtonInfo from '@shared/components/ButtonInfo.vue'

const router = useRouter()

const startSurvey = () => {
  router.push({
    name: ROUTE.ASSESSMENT_CAT_QUESTIONS,
  })
}
</script>

<style lang="scss" scoped>
.figure {
  text-align: center;

  img {
    width: 70%;
    max-width: 420px;
  }
}
</style>
